import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from '@app/shared/backend/clients';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

@Pipe({
    name: 'fullUserName',
    pure: true,
    standalone: false
})
export class FullUserNamePipe implements PipeTransform {
  private userCache: { [key: string]: Observable<string> } = {};

  constructor(
    private translate: TranslateService,
    private usersService: UsersService
  ) { }

  transform(userId: string | null | undefined): Observable<string> {
    if (!userId) return of('');

    const userIdString = userId.toString();

    if (this.userCache[userIdString]) {
      return this.userCache[userIdString];
    }

    // Create and cache the observable
    const userNameObservable = this.usersService.apiUsersIdGet(userId.toString()).pipe(
      map(userData => {
        if (userData && userData.firstName && userData.lastName) {
          return `${userData.firstName} ${userData.lastName}`;
        }
        return this.translate.instant('NO_DATA.SYMBOL');
      }),
      catchError(err => {
        console.error('Error fetching user data:', err);
        return of('Error fetching user data');
      }),
      shareReplay(1) // Prevents multiple calls for the same userId
    );

    this.userCache[userId.toString()] = userNameObservable;
    return userNameObservable;
  }
}
